import { Route, Routes } from 'react-router-dom';
import { BoardsContainer as Boards } from './boards';
import { BoardContainer as Board } from './board';
import { CardContainer } from './card';
import { DeliveryContainer } from './delivery';
import { MilestoneContainer } from './milestone';
import Error from '../common/Error';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Boards />} />
    <Route path="/:communityId/:roomId/boards/:boardId" element={<Board />} />
    <Route path="/:communityId/:roomId/boards/:boardId/create-card" element={<CardContainer />} />
    <Route path="/:communityId/:roomId/boards/:boardId/cards/:cardId" element={<CardContainer />} />
    <Route
      path="/:communityId/:roomId/boards/:boardId/milestoneset/:milestoneFolderId/create-milestone"
      element={<MilestoneContainer />}
    />
    <Route
      path="/:communityId/:roomId/boards/:boardId/milestoneset/:milestoneFolderId/milestones/:milestoneId"
      element={<MilestoneContainer />}
    />
    <Route path="/:communityId/:roomId/boards/:boardId/create-delivery" element={<DeliveryContainer />} />
    <Route path="/:communityId/:roomId/boards/:boardId/deliveries/:deliveryId" element={<DeliveryContainer />} />
    <Route path="*" element={<Error />} />
  </Routes>
);

export default AppRoutes;
